import { render, staticRenderFns } from "./profit-analysis.vue?vue&type=template&id=3576bc02&scoped=true&"
import script from "./profit-analysis.vue?vue&type=script&lang=js&"
export * from "./profit-analysis.vue?vue&type=script&lang=js&"
import style0 from "./profit-analysis.vue?vue&type=style&index=0&id=3576bc02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3576bc02",
  null
  
)

export default component.exports